import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { HandleError } from '../../core/models/handle-error';
import { AnalyticsService } from '../../core/services/analytics/analytics.service';
import { AuthService } from '../../core/services/auth/auth.service';
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { UserProfileService } from '../user-profile/user-profile.service';
import { PartsBulletinsService } from './parts-bulletins.service';
import { NgIf, NgFor, NgStyle, NgClass, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { SearchFilterPipe } from '../../shared/pipes/search-filter.pipe';
import { SortByFilterPipe } from '../../shared/pipes/sort-by-filter.pipe';
import { FilterResultsPipe } from '../../shared/pipes/filter-results.pipe';

@Component({
    selector: 'app-parts-bulletins',
    templateUrl: './parts-bulletins.component.html',
    styleUrls: ['./parts-bulletins.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        FormsModule,
        NgFor,
        NgStyle,
        RouterLink,
        NgClass,
        NgxPaginationModule,
        DatePipe,
        SearchFilterPipe,
        SortByFilterPipe,
        FilterResultsPipe,
    ],
})
export class PartsBulletinsComponent implements OnInit, OnDestroy {

  public screenWidth: number;
  private subscription: ISubscription[];
  public isShowAll = false;
  public isShowNew = false;
  public isShowHistory = false;
  public isShowSaved = false;
  APP_SETTINGS: any;
  public newDocsCount: number;
  public partsBulletins: any;
  public expandPbs = {};
  public serviceError = 'Loading data. Please wait...';

  // side bar or modal variables
  public mainGroupList = [];
  public bodyTypeList = [];
  public fromYears: number[] = [];
  public toYears: number[] = [];
  private currentYear: number;
  public sortBy = [];
  public inputMainGroup;
  public inputSeries = '';
  public inputBody;
  public inputFromYear;
  public inputToYear;
  public inputSortBy;
  public filter = { group: '', series: '', body: '', from: '', to: '' };

  public search4bulletins;

  // variables to update sort icons
  isDesc = false;
  column = '';
  direction: number;

  errorMessage: string;
  noContent: boolean;
  private username: string;

  constructor(
    private utilityService: UtilityService,
    private changeDetector: ChangeDetectorRef,
    private bulletinService: PartsBulletinsService,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private analyticsService: AnalyticsService,
    private userProfileService: UserProfileService,
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.username = this.authService.getUserName();
    if (APP_SETTINGS.isMOTORRAD === "true") {
      this.mainGroupList = APP_SETTINGS.motorradMainGroupList;
    }
    else {
      this.mainGroupList = APP_SETTINGS.mainGroupList;
    }
    this.APP_SETTINGS = APP_SETTINGS;
    this.search4bulletins = (APP_SETTINGS.currentPage == 'parts') ? this.bulletinService.getFilterData() : '';
    APP_SETTINGS.currentPage = 'parts';
    this.sortBy = [
      { key: 'bulletinNumber', value: 'Bulletin Number' },
      { key: 'description', value: 'Bulletin Title' },
      { key: 'releaseDate', value: 'Date' }
    ];

    this.currentYear = (new Date()).getFullYear();
    for (let year = 1985; year < this.currentYear + 1; year++) {
      this.fromYears.push(year);
      this.toYears.push(year);
    }

    this.subscription = [];
    if (APP_SETTINGS.partsBulletin == 'all') { this.showAll(); }
    if (APP_SETTINGS.partsBulletin == 'new') { this.showNew(); }
    if (APP_SETTINGS.partsBulletin == 'history') { this.showHistory(); }
    if (APP_SETTINGS.partsBulletin == 'saved') { this.showSaved(); }
    this.partsBulletins = [];

  }
  showAll() {
    APP_SETTINGS.partsBulletin = 'all';
    this.spinnerService.show('bmwSpinner');
    this.isShowAll = true;
    this.isShowNew = false;
    this.isShowHistory = false;
    this.isShowSaved = false;
    this.errorMessage = '';
    this.noContent = false;
    this.subscription.push(this.bulletinService.getAllPartsBulletins().subscribe(data => {
      this.partsBulletins = data['content'];
      this.newDocsCount = data['newSize'];
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  showNew() {
    this.isShowHistory = false;
    APP_SETTINGS.partsBulletin = 'new';
    this.spinnerService.show('bmwSpinner');
    this.isShowNew = true;
    this.isShowAll = false;
    this.isShowSaved = false;
    this.errorMessage = '';
    this.noContent = false;
    this.subscription.push(this.bulletinService.getNewPartsBulletins().subscribe(data => {
      this.partsBulletins = data;
      if (this.partsBulletins.length === 0) {
        this.errorMessage = 'No New Parts Bulletins';
        this.noContent = true;
      }
      this.newDocsCount = this.partsBulletins.length;
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.errorMessage = 'No New Parts Bulletins';
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  showHistory() {
    this.spinnerService.show('bmwSpinner');
    APP_SETTINGS.partsBulletin = 'history';
    this.isShowHistory = true;
    this.isShowAll = false;
    this.isShowNew = false;
    this.isShowSaved = false;
    this.errorMessage = '';
    this.noContent = false;
    this.subscription.push(this.bulletinService.getHistoryPartsBulletins(this.username).subscribe(data => {
      this.partsBulletins = data;
      if (this.partsBulletins.length === 0) {
        this.errorMessage = 'No History Found';
        this.noContent = true;
      }
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.errorMessage = 'No History Found';
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  showSaved() {
    this.isShowAll = false;
    this.isShowNew = false;
    this.isShowHistory = false;
    this.isShowSaved = true;
    this.errorMessage = '';
    this.noContent = true;
    APP_SETTINGS.partsBulletin = 'saved';
    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.bulletinService.getUserSavedPartsBulletins(this.username).subscribe(data => {
      this.partsBulletins = data;
      if (this.partsBulletins.length === 0) {
        this.errorMessage = 'No Saved Bulletins';
      }
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  addBulletinToHistory(isSaved, id, bulletinDisplayNumber) {
    this.bulletinService.saveFilterData(this.search4bulletins);
    if (!isSaved) {
      this.subscription.push(this.bulletinService.addBulletinToUserHistory(this.username, id).subscribe());
    }

    //Analytics Call
    if (APP_SETTINGS.isAdmin === 'true') {
      this.analyticsService.trackClicksbyAdminUser('Parts Bulletins', bulletinDisplayNumber, this.username);
    }
    else {
      this.analyticsService.trackClicksByDocumentsContentTypeLineMake('Parts Bulletins', bulletinDisplayNumber);
    }
    if (APP_SETTINGS.isExternal === 'true') {
      this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
        this.analyticsService.trackClicksByExternalContentType('Parts Bulletins', bulletinDisplayNumber, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
      });
    }
    if (APP_SETTINGS.isDealer === 'true') {
      this.analyticsService.trackDealerContentTypeLocation('Parts Bulletins', bulletinDisplayNumber, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
        APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription)
    }

  }
  

  sortByProperty(propertyParam) {
    this.isDesc = !this.isDesc; // change the direction
    this.column = propertyParam;
    this.direction = this.isDesc ? 1 : -1;
  }
  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
  applyFilter() {
    let mainGroupCode = '';
    if (this.inputMainGroup) {
      const matchString = this.inputMainGroup.match(/\[(.*?)\]/)[1];
      if (APP_SETTINGS.isMOTORRAD === 'true') {
        mainGroupCode = matchString;
      } else {
        mainGroupCode = +matchString < 10 ? '0' + matchString : matchString;
      }
    }
    this.filter = {
      group: mainGroupCode,
      series: this.inputSeries.trim(),
      body: this.inputBody,
      from: this.inputFromYear,
      to: this.inputToYear
    };
    if (this.inputSortBy && this.inputSortBy.length > 0) {
      this.sortByProperty(this.inputSortBy);
    }
  }
  clearFilter() {
    this.inputMainGroup = this.inputSortBy = undefined;
    this.inputFromYear = this.inputToYear = '';
    this.filter = { group: '', series: '', body: '', from: '', to: '' };
  }
  ngOnDestroy(): void {
    this.subscription.forEach(s => s.unsubscribe());
  }
  pageNumChange(event) {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }
}
